import { getStorageByType } from '@/_utils/get-storage-by-type';
import { EStorageType } from '@/_utils/_types';

type TSetCacheParams<TData> = {
  key: string;
  defaultValue: TData;
  storageType?: EStorageType;
};

export const getCache = <TData>({
  key,
  defaultValue,
  storageType = EStorageType.localStorage,
}: TSetCacheParams<TData>): TData => {
  const storage = getStorageByType({ storageType });

  if (!storage) {
    return defaultValue;
  }

  const rawValue = storage.getItem(key);

  if (rawValue === null) {
    return defaultValue;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    console.error(error);

    // base64 case
    return rawValue as TData;
  }
};
